import { render, staticRenderFns } from "./ModalOrientacaoFranquia.vue?vue&type=template&id=7b8cefd4"
import script from "./ModalOrientacaoFranquia.vue?vue&type=script&lang=js"
export * from "./ModalOrientacaoFranquia.vue?vue&type=script&lang=js"
import style0 from "./ModalOrientacaoFranquia.vue?vue&type=style&index=0&id=7b8cefd4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports